import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import {
    updatePaymentProfile as updatePaymentProfileApi,
    UpdatePaymentProfileApiParameter,
} from "@insite/client-framework/Services/AccountService";
import {
    DispatchResetPaymentProfiles,
    ExecuteOnSuccessCallback,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/PaymentProfiles/Handlers/UpdatePaymentProfile";
import { AccountPaymentProfileModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<
    UpdatePaymentProfileApiParameter & HasOnSuccess & HasOnError<string>,
    AccountPaymentProfileModel
>;

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await updatePaymentProfileApi(props.parameter);
    } catch (error) {
        if ("errorMessage" in error) {
            props.parameter.onError?.(error.errorMessage as string);
        }

        return false;
    }
};

export const chain: HandlerType[] = [
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchResetPaymentProfiles,
    ExecuteOnSuccessCallback,
];

const updatePaymentProfileWithError = createHandlerChainRunner(chain, "UpdatePaymentProfileWithError");
export default updatePaymentProfileWithError;
